export default __webpack_public_path__ + "static/media/news-11.3ee9f2e4.jpg";